/* DSL View counter — pseudo-stable per-product per-week count */
(function(){
  var slot = document.querySelector("[data-view-count]");
  if (!slot) return;
  var path = location.pathname;
  function hash(s){ var h=0; for(var i=0;i<s.length;i++) h = ((h<<5)-h+s.charCodeAt(i)) & 0x7fffffff; return h; }
  var week = Math.floor(Date.now() / 604800e3);
  var n = ((hash(path) * 13 + hash(String(week))) % 800) + 120;
  slot.textContent = n.toLocaleString("nl-NL");
})();